import React from 'react';


const CustomSelect = (props) => {
	return props.orientation === "labeled" ? (
		<div className="form-group">
			<table>
        <tbody>
          <tr>
			  <td style={{ width: "25%", textAlign:"left"  }}>
			<label htmlFor={props.name}> {props.title}{props.required?("*"):("")} </label>
				  </td>
			  <td style={{ width: "75%" }}>
		    <select
		      id = {props.name}
		      name={props.name}
		      value={props.value}
		      onChange={props.handleChange}
		      className="form-control custom_input">
		      <option value="" disabled>{props.placeholder}</option>
		      {props.options.map(option => {
		        return (
		          <option
		            key={option}
		            value={option}
		            label={option}>{option}</option>
		        );
		      })}
		    </select>
				  </td>
		  </tr>
        {props.error ? (<tr>
            <td style={{ width: "25%" }}/>
            <td>
              <div className="invalid-feedback" style={{ display: "block", textAlign:"left" }}>
                {props.error}
              </div>
            </td>
          </tr>):null}</tbody></table>
  </div>
	):(
	<div className="form-group">
		{props.title ? (<label htmlFor={props.name}> {props.title} </label>) : null }
		    <select
		      id = {props.name}
		      name={props.name}
		      value={props.value}
		      onChange={props.handleChange}
		      className="form-control">
		      <option value="" disabled>{props.placeholder}</option>
		      {props.options.map(option => {
		        return (
		          <option
		            key={option}
		            value={option}
		            label={option}>{option}</option>
		        );
		      })}
		    </select>
		{props.error ? (
              <div className="invalid-feedback" style={{ display: "block", textAlign:"left" }}>
                {props.error}
              </div>):null}
  </div>)
};

export default CustomSelect;